module.exports = __webpack_public_path__ + "static/media/powered.5bcb939b.svg";